import { render, staticRenderFns } from "./SkeletonProductsList.vue?vue&type=template&id=4cea54e2&"
import script from "./SkeletonProductsList.vue?vue&type=script&lang=js&"
export * from "./SkeletonProductsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports